export default `
  mutation generateApiKey($expiresInDays: Int) {
    generateApiKey(expiresInDays: $expiresInDays) {
      apiKey
      expiresAt
    }
  }
`
